import {
  Component,
  Injectable,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {
  @Input() textMessage: String;
  @Output() passConfirm: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  closeModal(confirm: boolean) {
    this.passConfirm.emit(confirm);
  }
}
